import { Injectable } from '@angular/core';
import { GlobalService } from '@common/global';
import { ApiService } from '@services/api.service';
import { HttpParams } from '@angular/common/http'
@Injectable({
  providedIn: 'root'
})
export class PageService {
  constructor(private _global: GlobalService, private api: ApiService) { }
  application(obj) {
    let params = new HttpParams();
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
      if (key == 'component') {
        params = params.append(key, this._global.getComponent(v));
      } else {
        params = params.append(key, v);
      }
    });
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
    return this.api.call( 'service/search/page', params);
  }
  view(obj) {
    let params = new HttpParams();
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
      if (key == 'component') {
        params = params.append(key, this._global.getComponent(v));
      } else {
        params = params.append(key, v);
      }
    });
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
    return this.api.call( 'page/view', params);
  }
  
}

